import React from 'react';
import { Theme, makeStyles, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'absolute',
            left: '20px',
            right: '20px',
            bottom: '0px',
            transform: 'translateY(50%)',
            display: 'inline-block',
            justifyContent: 'space-between',
            width: '90%',
        },
        dot: {
            display: 'block',
            float: 'right',
            width: theme.spacing(1),
            height: theme.spacing(1),
            border: '3px solid rgb(224, 44, 22)',
            borderRadius: '50%',
            marginLeft: '10%',
        },
    }),
);

const Dots = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.dot} />
            <span className={classes.dot} />
            <span className={classes.dot} />
            <span className={classes.dot} />
            <span className={classes.dot} />
        </div>
    );
};

export default Dots;
